<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_admins" autocomplete="off">
                <v-layout row wrap>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="admins.admin_name" type="text"
                            :label="$store.getters.lang.data.admin_name" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="admins.admin_password" type="text"
                            :label="$store.getters.lang.data.admin_password" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large >{{$store.getters.lang.data.add_btn}} admins</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            {{$store.getters.lang.data.admins}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="admin_id">
                                <template v-slot:[`item.admin_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_admins(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/admins-list/'+item.admin_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_admins(selected_admins.admin_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/admins'
    export default {
        data() {
            return {
                admins: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_admins: {},
                delete_dialog: false,
                headers: [

                    


                    {
                        text: this.$store.getters.lang.data.admin_name,
                        align: 'start',
                        sortable: true,
                        value: 'admin_name',
                    },


                    {
                        text: this.$store.getters.lang.data.admin_password,
                        align: 'start',
                        sortable: true,
                        value: 'admin_password',
                    },
                    {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'admin_id',
                    },


                ],
            }
        },
        computed: {
            rows() {
                return this.$store.getters.admins
            },


        },
        mounted() {
            this.read_admins();
        },
        methods: {
            add_admins() {
                controller.add_admins(this.admins).then(r => {
                    if (r.data) {
                        this.admins = {}
                        this.$store.state.admins.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'admins Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add admins',
                            color: 'error'
                        }
                    }
                })
            },
            delete_admins(admin_id) {
                controller.delete_admins(admin_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.admins = this.$store.state.admins.filter(f => {
                            return f.admin_id != admin_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'admins Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_admins() {
                this.loading = true
                controller.get_admins().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_admins(i) {
                this.selected_admins = i
                this.delete_dialog = true
            },
        },
    }
</script>